import { Moon, Sun } from '../../assets';
import React from 'react';

const ThemeBtn = ({ theme, changeTheme }) => {
  return (
    <>
      <button onClick={changeTheme}>
        <div className="bg-secondary px-4 py-2 flex gap-2 items-center justify-end border-tertiary border-2 rounded-full">
          {theme === 'dark' ? (
            <>
              <div className="text-sm whitespace-nowrap sm:hidden qw:inline">
                Light Mode
              </div>
              <div className="min-w-6">
                <Sun className="svg-dynamic-color" />
              </div>
            </>
          ) : (
            <>
              <div className="text-sm whitespace-nowrap sm:hidden qw:inline">
                Dark Mode
              </div>
              <div className="min-w-6">
                <Moon className="svg-dynamic-color" />
              </div>
            </>
          )}
        </div>
      </button>
    </>
  );
};

export default React.memo(ThemeBtn);
